import { Flex, Box } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

type SubHeaderProps = {
  partnerSubHeaderText?: string;
  partnerName?: string;
};

export const SubHeader = ({
  partnerSubHeaderText,
  partnerName,
}: SubHeaderProps) => {
  const subheaderLogoClasses = classNames("mobius-header__subheader-logo", {
    [`${partnerName}`]: partnerName,
  });

  return (
    <div className="mobius-header__subheader">
      <Flex
        className="mobius-header__subheader-content"
        justifyContent="center"
        alignItems="center"
        gap="xxs"
      >
        <span>In partnership with</span>
        {partnerSubHeaderText ? (
          <strong>{partnerSubHeaderText}</strong>
        ) : (
          <Box className={subheaderLogoClasses} />
        )}
      </Flex>
    </div>
  );
};
